module.exports = __webpack_public_path__ + "img/security7.7cf00c76.png";